import React from 'react';
class Juxtapose extends React.Component {
    constructor(props) {
        super(props);
        this.handleMouseOut = this.handleMouseOut.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.state = {
            designer: {
                opacity: 1
            },
            coder: {
                opacity: 1
            },
            designerBg: {
                opacity: 1,
                left: "70px"
            },
            coderBg: {
                opacity: 1,
                right: "70px"
            },
            coderImg: {
                width: "283px",
                opacity: 1,
                right: "calc(50% - 283px)",
                zIndex: 15
            },
            designerImg: {
                width: "283px",
                opacity: 1,
                left: "calc(50% - 283px)",
                zIndex: 15
            }
        }
    }

    handleMouseMove(event) {
        const x = event.clientX;
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const middleOffset = vw / 2 - x;
        const positionDelta = middleOffset / 5;
        const opacityDelta = middleOffset / (vw / 2) * 1.25;
        if (middleOffset < 0) {
            this.moveCoderImage(Math.abs(middleOffset));
        } else {
            this.moveDesignerImage(Math.abs(middleOffset));
        }

        this.setState({ designerBg: { opacity: 1 + opacityDelta, left: (70 + positionDelta) + "px" } })
        this.setState({ coderBg: { opacity: 1 - opacityDelta, right: (70 - positionDelta) + "px" } })
        this.setState({ designer: { opacity: 1 + opacityDelta } })
        this.setState({ coder: { opacity: 1 - opacityDelta } })
    }

    handleMouseOut(event) {
        this.setState({
            designer: {
                opacity: 1
            },
            coder: {
                opacity: 1
            },
            designerBg: {
                opacity: 1,
                left: "70px"
            },
            coderBg: {
                opacity: 1,
                right: "70px"
            },
            coderImg: {
                width: "283px",
                opacity: 1,
                right: "calc(50% - 283px)",
                zIndex: 15
            },
            designerImg: {
                width: "283px",
                opacity: 1,
                left: "calc(50% - 283px)",
                zIndex: 15
            }
        })
    }

    moveCoderImage(offset) {
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        let positionDelta = 0;
        let widthDelta = 0;
        let opacityDelta = 0;
        if (offset > vw / 4) {
            widthDelta = 566;
            opacityDelta = 1;
        } else {
            widthDelta = offset / 2;
            opacityDelta = offset * 0.002;
        }
        positionDelta = 75 * offset / (vw / 4);
        this.setState({ coderImg: { ...this.state.coderImg, width: 283 + widthDelta + "px", right: "calc(50% - " + (283 - positionDelta) + "px)", zIndex: "16" } })
        this.setState({ designerImg: { ...this.state.designerImg, opacity: 1 - opacityDelta, left: "calc(50% - " + (283 + positionDelta) + "px)", zIndex: "15" } })
    }

    moveDesignerImage(offset) {
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        let positionDelta = 0;
        let widthDelta = 0;
        let opacityDelta = 0;
        if (offset > vw / 4) {
            widthDelta = 566;
            opacityDelta = 1;
        } else {
            widthDelta = offset / 2;
            opacityDelta = offset * 0.002;
        }
        positionDelta = 75 * offset / (vw / 4);

        this.setState({ coderImg: { ...this.state.coderImg, opacity: 1 - opacityDelta, right: "calc(50% - " + (283 + positionDelta) + "px)", zIndex: "15" } })
        this.setState({ designerImg: { ...this.state.designerImg, width: 283 + widthDelta + "px", left: "calc(50% - " + (283 - positionDelta) + "px)", zIndex: "16" } })
    }
    componentDidMount() {
    }
    render() {
        const imgPath = require("../../../assets/img/portrait.jpg");
        return (
            <div onMouseMove={this.handleMouseMove} onMouseOut={this.handleMouseOut} className="juxtapose-wrapper">
                < div className="desktop" >
                    <div style={this.state.designer} className="designer">
                        <div id="designer-desc" className="description">
                            <div className="title">
                                <span>D</span>esigner
                    </div>
                            <p>User Interface (UI) / User Experience (UX) Designer with a passion for designing unique and appealing interfaces.</p>
                        </div>
                    </div>
                    <div style={this.state.designerBg} className="desginer-bg">

                    </div>
                    <div style={this.state.designerImg} className="designer-img">

                    </div>
                    <div style={this.state.coder} className="coder">
                        <div id="coder-desc" className="description">
                            <div className="title">
                                <span>D</span>eveloper
                    </div>
                            <p>Full-stack  Web Developer who focuses on writing highly efficient, well-structured and maintainable code.</p>
                        </div>
                    </div>
                    <div style={this.state.coderBg} className="coder-bg">

                    </div>
                    <div style={this.state.coderImg} className="coder-img">

                    </div>
                </div >
                <div className="mobile">
                    <div className="section profile">
                        <img src={imgPath} alt="Adrian Manduc" />
                    </div>
                    <div className="section developer">
                        <div className="icon">
                            <i className="fa fa-code fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="title">
                            <span>D</span>eveloper
      </div>
                        <p>Full-stack  Web Developer who focuses on writing highly efficient, well-structured and maintainable code.</p>
                    </div>
                    <div className="section designer">
                        <div className="icon">
                            <i className="fa fa-paint-brush fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="title">
                            <span>D</span>esigner
      </div>
                        <p>User Interface (UI) / User Experience (UX) Designer with a passion for designing unique and appealing interfaces.</p>
                    </div>
                </div>
            </div >
        )
    }
}

export default Juxtapose;


// WEBPACK FOOTER //
// ./src/components/home/Juxtapose/juxtapose.js